import * as React from 'react';
import { SVGProps } from 'react';

const IconDisconnectionSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.515 13.414a5 5 0 0 0 7.07 7.071L12.5 18.5c-.5-.5-.5-.5-1.437-1.32l-1.89 1.891a3 3 0 1 1-4.243-4.243l3.535-3.535L7.05 9.879l-3.535 3.535zm9.515-6.686 1.798-1.8a3 3 0 0 1 4.243 4.244l-3.536 3.535 1.415 1.414 3.535-3.535a5 5 0 0 0-7.07-7.071l-1.916 1.984c.5.5.5.5 1.53 1.229zm4.932 11.342-3-2 1-1 3 2-1 1zM15.5 20.5l-2-3 1-1 2 3-1 1zM5.929 6l3 2-1 1-3-2 1-1zm2.648-2.485 2 3-1 1-2-3 1-1z" />
  </svg>
);
export default IconDisconnectionSizeM;
